/**
 * SNES Chat - Gate Screen
 *
 * Magic word gate for accessing the chat interface.
 * User Story 1: Access Gate Entry (Priority: P1)
 */

import { setGatePassed as stateSetGatePassed, isGatePassed } from './state';

// ============================================================================
// Constants
// ============================================================================

// ============================================================================
// Validation
// ============================================================================

/**
 * Validate the magic word (no longer required — always passes)
 */
export function validateMagicWord(_input: string): boolean {
  return true;
}

/**
 * Check if gate is already passed
 * T021: Uses state management
 */
export function checkGateStatus(): boolean {
  return isGatePassed();
}

/**
 * Set gate as passed
 * T022: Uses state management
 */
export function setGatePassed(): void {
  stateSetGatePassed();
}

// ============================================================================
// UI State
// ============================================================================

/**
 * Handle enter button click
 */
function handleEnter(event: Event): void {
  event.preventDefault();
  console.log('[Gate] Enter clicked');
  setGatePassed();
}

// ============================================================================
// Rendering
// ============================================================================

/**
 * Render the gate screen
 * T023-T024: Create renderGateScreen with input handling
 */
export function renderGateScreen(container: HTMLElement): void {
  container.innerHTML = `
    <div class="screen screen-centered gate-screen">
      <div class="dialog-box gate-dialog">
        <div class="gate-header">
          <h1 class="gate-title">TRACKAA</h1>
          <p class="gate-subtitle">Aircraft Maintenance Tracker</p>
        </div>

        <div class="gate-content">
          <p class="gate-prompt">
            Real-time aircraft tracking and maintenance analysis.
          </p>

          <button id="gate-enter-btn" class="btn gate-btn">
            ENTER
          </button>
        </div>
      </div>
    </div>
  `;

  // Add gate-specific styles
  addGateStyles();

  // Attach button handler
  const btn = document.getElementById('gate-enter-btn');
  if (btn) {
    btn.addEventListener('click', handleEnter);
  }
}

/**
 * Add gate-specific CSS
 */
function addGateStyles(): void {
  const styleId = 'gate-styles';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    .gate-screen {
      background: linear-gradient(
        180deg,
        var(--snes-dark-blue) 0%,
        var(--snes-black) 100%
      );
    }

    .gate-dialog {
      max-width: 360px;
      width: 90%;
      text-align: center;
    }

    .gate-header {
      margin-bottom: var(--space-lg);
    }

    .gate-title {
      font-size: var(--font-size-lg);
      color: var(--snes-yellow);
      margin-bottom: var(--space-sm);
      text-shadow: 2px 2px 0 var(--snes-black);
    }

    .gate-subtitle {
      font-size: var(--font-size-xs);
      color: var(--snes-light-blue);
    }

    .gate-prompt {
      font-size: var(--font-size-sm);
      margin-bottom: var(--space-md);
    }

    .gate-form {
      display: flex;
      flex-direction: column;
      gap: var(--space-sm);
    }

    .gate-input {
      text-align: center;
      font-size: var(--font-size-lg);
      letter-spacing: 4px;
    }

    .gate-btn {
      width: 100%;
    }

    .gate-error {
      margin-top: var(--space-sm);
      animation: shake 0.3s ease-in-out;
    }

    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      25% { transform: translateX(-5px); }
      75% { transform: translateX(5px); }
    }

    .gate-footer {
      margin-top: var(--space-lg);
      border-top: 2px solid var(--snes-gray);
      padding-top: var(--space-md);
    }

    .gate-hint {
      font-size: var(--font-size-xs);
      color: var(--snes-gray);
    }
  `;

  document.head.appendChild(style);
}
